enum AccessGroupsAssetsConstants {
  PATCH_ACCESS_GROUPS_ASSETS = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS',
  PATCH_ACCESS_GROUPS_ASSETS_INIT = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_INIT',
  PATCH_ACCESS_GROUPS_ASSETS_REQUEST = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_REQUEST',
  PATCH_ACCESS_GROUPS_ASSETS_RESPONSE = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_RESPONSE',
  PATCH_ACCESS_GROUPS_ASSETS_REQUEST_SUCCESS = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_REQUEST_SUCCESS',
  PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ERROR = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ERROR',

  // These flags are used to track effects of completed add and delete operations respectively
  PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_ADDED = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_ADDED',
  PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_DELETED = '@AccessGroupsAssets/PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_DELETED',
}

export default AccessGroupsAssetsConstants;
